module.exports = __webpack_public_path__ + "static/media/logom.f5362bcc.jpg";